import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "antd";
import { getYoutubeVideosFetch } from "./API";
import "./css/index.css";

const YoutubeVideos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  const getVideos = async () => {
    setLoading(true);
    const data = await getYoutubeVideosFetch();
    setVideos(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => {
    getVideos();
  }, []);

  // ซ่อน section ทั้งหมดถ้ายังโหลดอยู่ หรือไม่มีวิดีโอ
  if (loading || !videos.length) return null;

  return (
    <div className="youtube-videos">
      <div className="container">
        <h2 className="yt-title">วิดีโอล่าสุดจากช่อง YouTube</h2>

        <Row gutter={[24, 24]}>
          {videos.map((v) => (
            <Col xs={24} sm={12} lg={6} key={v.videoId}>
              <div className="yt-card" onClick={() => setActiveVideo(v)}>
                <div className="yt-thumb">
                  <img src={v.thumbnailUrl} alt={v.title} loading="lazy" />
                  <span className="yt-play" />
                </div>
                <div className="yt-card-title">{v.title}</div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      <Modal
        open={!!activeVideo}
        onCancel={() => setActiveVideo(null)}
        footer={null}
        width={860}
        centered
        destroyOnClose
        title={activeVideo?.title}
      >
        {activeVideo && (
          <div className="yt-player">
            <iframe
              src={`${activeVideo.embedUrl}?autoplay=1&rel=0`}
              title={activeVideo.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default YoutubeVideos;
